import { render, staticRenderFns } from "./unitCreditTask.vue?vue&type=template&id=53893a92&scoped=true"
import script from "./unitCreditTask.vue?vue&type=script&lang=js"
export * from "./unitCreditTask.vue?vue&type=script&lang=js"
import style0 from "./unitCreditTask.vue?vue&type=style&index=0&id=53893a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53893a92",
  null
  
)

export default component.exports